import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {GithubIssueDTO} from '../dto/github-issue';
import {environment} from '../../../environments/environment';
import {map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class GithubIssueService {
  private readonly http: HttpClient = inject(HttpClient);
  private readonly apiUrl = environment.apiBaseUrl + '/issue';

  createIssue(issue: GithubIssueDTO): Observable<boolean> {
    return this.http.post(`${this.apiUrl}`, issue, {observe: 'response'}).pipe(
      map(() => true)
    );
  }

}

